export enum PmMenuItemsIdsEnum {
  PM_INFO = 'PM_INFO',
  PM_WARNING = 'PM_WARNING',
  PM_REASONS = 'PM_REASONS',
  PM_EVENTS = 'PM_EVENTS',
  PM_SUBJECT = 'PM_SUBJECT',
  PM_ACT = 'PM_ACT',
  PM_OBJECTS = 'PM_OBJECTS',
  PM_INSPECTORS = 'PM_INSPECTORS',
  PM_EVENT_SUBJECT = 'PM_EVENT_SUBJECT',
  PM_COLLABORATING_ORGANIZATION = 'PM_COLLABORATING_ORGANIZATION',
  PM_IS_REJECT_SUBJECT = 'PM_IS_REJECT_SUBJECT',
  PM_RESULT_OF_INSPECTION = 'PM_RESULT_OF_INSPECTION',
  PM_SIGN_INFO = 'PM_SIGN_INFO',
  PM_EPGU_NOTIFICATION = 'PM_EPGU_NOTIFICATION',
  PM_HISTORY = 'PM_HISTORY',
  PM_NOTIFICATION = 'KNM_NOTIFICATION',
  PM_REJECT = 'PM_REJECT',
  PM_AGREEMENTS = 'PM_AGREEMENTS',
  KNM_REPEAT_PASSPORTS = 'KNM_REPEAT_PASSPORTS',
}
